import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      try {
        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
          // No session in hash — user reached this page wrongly; go home.
          navigate("/");
          return;
        }
        const sessionId = match[1];
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Bearer fallback for mobile Safari ITP (cookies may be blocked across subdomains)
        if (data.session_token) {
          localStorage.setItem("helencia_token", data.session_token);
        }
        // Replace history entry so the user can't go back to the hash URL,
        // then redirect to /dashboard which handles role-based routing.
        window.location.replace("/dashboard");
      } catch (e) {
        // Surface the error to the user instead of bouncing to home silently.
        const detail = e?.response?.data?.detail;
        const msg = typeof detail === "string"
          ? detail
          : e?.userMessage || "Impossible de finaliser la connexion. Réessayez.";
        // eslint-disable-next-line no-console
        console.error("Auth callback error:", e);
        setError(msg);
      }
    };
    run();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" data-testid="auth-callback-error">
        <div className="max-w-md text-center">
          <p className="caption-label text-[#A26F3E] mb-2">Connexion impossible</p>
          <h1 className="font-serif text-3xl text-[#1A1A1A] mb-4">Un problème est survenu</h1>
          <p className="text-sm text-[#6E4B2A] mb-6">{error}</p>
          <button
            onClick={() => { window.location.href = "/login"; }}
            className="inline-flex items-center gap-2 rounded-full bg-[#C68E59] hover:bg-[#A26F3E] text-white h-11 px-6 text-sm font-semibold"
            data-testid="auth-callback-retry"
          >
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#1A1A1A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-serif text-xl text-[#1A1A1A]">Connexion en cours…</p>
      </div>
    </div>
  );
}
